import { Group, Skeleton, Stack } from '@mantine/core';
import Card from 'components/Card';
import React from 'react';
import { HiOutlineDocumentText } from 'react-icons/hi';

const LoaderSection = () => {
  return (
    <Card>
      <Stack gap={16}>
        <Group gap={8}>
          <HiOutlineDocumentText />
          <Skeleton h={24} w={175} />
        </Group>
        {[...Array(5)].map((_, i) => (
          <Stack gap={4} key={i}>
            <Skeleton h={16} w={100} />
            <Skeleton h={16} w={250} />
          </Stack>
        ))}
      </Stack>
    </Card>
  );
};

export default LoaderSection;
